import {
  LRLanguage,
  LanguageSupport,
  StreamLanguage,
} from '@codemirror/language';
import { ruby } from '@codemirror/legacy-modes/mode/ruby';
import { parseMixed } from '@lezer/common';
import { parser } from './parser';

export const rubyTemplateLanguage = LRLanguage.define({
  name: 'rubyTemplate',
  parser: parser.configure({}),
  languageData: {},
});

export function rubyTemplate() {
  return new LanguageSupport(
    rubyTemplateLanguage.configure({
      wrap: parseMixed(node => {
        return node.name == 'TemplateContent'
          ? {
              parser: StreamLanguage.define(ruby).parser,
            }
          : null;
      }),
    }),
    [StreamLanguage.define(ruby).extension],
  );
}
